<template>
  <div class="policy-proposals-page">
    <WeCircularNavbar />

    <section class="page-section hero-section">
      <div class="page-container">
        <h1 class="page-title">WE.Circular Policy Proposals</h1>

        <p class="page-intro">
          This section presents a structured methodology and evidence-based policy proposals aimed at addressing key
          challenges at regional and national levels across the Danube Region.
        </p>

        <div class="cards-grid">
          <article class="info-card">
            <div class="info-card__header">
              Policy Making Camp Methodology
            </div>

            <div class="info-card__body">
              <p>
                Explore a validated and tested co-creation methodology designed to support the development of targeted
                policy proposals aligned with local, regional and national needs.
              </p>

              <a
                href="https://vali.hu/static/D361_Concept_for_Policy_Making_Camp_FINAL.pdf"
                target="_blank"
                rel="noopener noreferrer"
                class="download-btn"
              >
                <img :src="downloadIcon" alt="" />
              </a>
            </div>
          </article>

          <article class="info-card">
            <div class="info-card__header">
              Co-design Workshop Methodology
            </div>

            <div class="info-card__body">
              <p>
                Explore a validated and tested co-creation methodology designed to support the development of the
                Regional Action Plans (RAPs).
              </p>

              <a
                href="https://vali.hu/static/Co-design_workshop_05062025.pdf"
                target="_blank"
                rel="noopener noreferrer"
                class="download-btn"
              >
                <img :src="downloadIcon" alt="" />
              </a>
            </div>
          </article>

          <article class="info-card">
            <div class="info-card__header">
              WE.Circular Policy Proposals
            </div>

            <div class="info-card__body">
              <p>
                Access concrete policy proposals developed through the co-creation workshop process, reflecting
                stakeholder input and region-specific priorities.
              </p>

              <a
                href="https://vali.hu/static/WeCircular_PolicyCamp_report_proposals.pdf"
                target="_blank"
                rel="noopener noreferrer"
                class="download-btn"
              >
                <img :src="downloadIcon" alt="" />
              </a>
            </div>
          </article>
        </div>
      </div>
    </section>

    <WeCircularFooter />
  </div>
</template>

<script>
import WeCircularNavbar from './WeCircularNavbar.vue'
import WeCircularFooter from './WeCircularFooter.vue'
import downloadIcon from '../../assets/img/we-circular/download_1.svg'

export default {
  name: 'WeCircularPolicyProposalsPage',
  components: {
    WeCircularNavbar,
    WeCircularFooter
  },
  data() {
    return {
      downloadIcon
    }
  }
}
</script>

<style scoped>
.policy-proposals-page {
  min-height: 100vh;
  background: #f4f7f8;
}

.page-section {
  width: 100%;
}

.page-container {
  max-width: 1240px;
  margin: 0 auto;
  padding: 40px 32px 64px;
  box-sizing: border-box;
}

.hero-section {
  padding-top: 24px;
}

.page-title {
  margin: 0 0 16px;
  font-size: 42px;
  line-height: 1.12;
  font-weight: 700;
  color: #0f4c97;
  text-align: left;
}

.page-intro {
  max-width: 620px;
  margin: 0 0 40px;
  font-size: 18px;
  line-height: 1.7;
  color: #4f6f8f;
  text-align: left;
}

.cards-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
  align-items: stretch;
}

.info-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 340px;
  border: 1px solid #2b6d6d;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 6px 18px rgba(17, 76, 111, 0.06);
}

.info-card__header {
  position: relative;
  padding: 28px 20px;
  background: url('../../assets/img/we-circular/16-9@4x.png') center / cover no-repeat;
  color: #ffffff;
  font-size: 20px;
  line-height: 1.25;
  font-weight: 700;
  text-align: center;
  overflow: hidden;
  min-height: 105px;

  display: flex;
  align-items: center;
  justify-content: center;
}

.info-card__body {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 28px 24px 22px;
  text-align: center;
}

.info-card__body p {
  margin: 0;
  font-size: 16px;
  line-height: 1.8;
  color: #1d5ea8;
}

.download-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  margin-top: 24px;
  border-radius: 8px;
  background: #0f4c97;
  transition: background 0.2s ease, transform 0.2s ease;
}

.download-btn:hover {
  background: #0c3d79;
  transform: translateY(-1px);
}

.download-btn img {
  width: 16px;
  height: 16px;
  object-fit: contain;
  display: block;
}

@media (max-width: 1100px) {
  .cards-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .page-container {
    padding: 30px 20px 48px;
  }

  .page-title {
    font-size: 30px;
  }

  .page-intro {
    font-size: 17px;
    line-height: 1.7;
  }

  .cards-grid {
    grid-template-columns: 1fr;
  }

  .info-card {
    min-height: 300px;
  }

  .info-card__header {
    padding: 22px 16px;
    font-size: 18px;
    min-height: 90px;
  }

  .info-card__body {
    padding: 22px 18px 20px;
  }

  .info-card__body p {
    font-size: 15px;
    line-height: 1.7;
  }
}
</style>
